import { useRouter } from 'next/router'

import { Container } from '@components/Container'
import { Comment } from '@components/Comment'
import { Cover } from '@features/story/pages/StoryPage/components/Cover'
import { Character } from '@features/story/pages/StoryPage/components/Character'
import { PayRank } from '@features/story/pages/StoryPage/components/PayRank'
import { Introduction } from '@features/story/pages/StoryPage/components/Introduction'
import { ShareButtons } from '@features/story/pages/StoryPage/components/ShareButtons'
import { WriterInformation } from '@features/story/pages/StoryPage/components/WriterInformation'
import { ChapterManage } from '@features/story/pages/StoryPage/components/ChapterManage'
import { NavigateOtherStory } from '@features/story/components/NavigateOtherStory'
import { DisabledCopyContent } from '@components/DisabledCopyContent'
import { RecommendedArticle } from '@components/RecommendedArticle'
import { StoryField } from './components/StoryField'
import { StoryPageProps } from './interface'
import { BookLink } from './components/BookLink'
import { ReadPromotion } from './components/ReadPromotion'
import { BuyAllPromotion } from './components/BuyAllPromotion'
import { BookPromotion } from './components/BookPromotion'
import { ErrorMessage } from '@components/ErrorMessage'
import { ChapterPromotion } from './components/ChapterPromotion'

export function StoryPage({ data, shareUrl, errorMessage }: StoryPageProps) {
  const { query } = useRouter()
  return (
    <div className='select-none relative'>
      <Container className='mobile:!p-[0_0_20px]'>
        <Cover />
      </Container>
      <DisabledCopyContent />
      <Character />
      <Container className='pb-[80px] mobile:pb-[20px] tablet:pt-[30px]'>
        <PayRank className='pt-[30px] mobile:pt-[20px] pb-[30px] mobile:pb-[20px]' />
        <StoryField className='mt-[20px]' />
        <Introduction className='desktop-tablet:mt-[20px]' />
        <BookLink className='p-[30px] mobile:p-[20px] desktop-tablet:mt-[20px]' />
        <ShareButtons
          className='border-none bg-transparent shadow-none mx-auto !mt-0 !py-[50px] mobile:!py-[40px] w-fit'
          type='story2'
          shareUrl={shareUrl}
          bookId={Number(data?.id)}
        />
        <WriterInformation />
        <ChapterPromotion />
        <ReadPromotion />
        <BuyAllPromotion />
        <BookPromotion />
        <ChapterManage className='mobile:py-[20px] mobile:mt-[10px]' />
        <ShareButtons
          className='border-none bg-transparent shadow-none mx-auto !mt-0 !py-[50px] mobile:!py-[40px] w-fit'
          type='story2'
          shareUrl={shareUrl}
          bookId={Number(data?.id)}
        />
        <RecommendedArticle
          className='mobile:py-[20px] mobile:pt-0'
          direction='vertical'
          isShowNavigation
          categoryId={data?.category?.id}
          bookType={data?.bookType}
          bookId={data?.id}
          isEbook={data?.isEbook}
          isStoryPage
        />
        <Comment
          className='mt-[50px] mobile:mt-0'
          bookId={Number(query?.id)}
          chapterId={Number(query?.chapterId)}
          authorUserId={Number(data?.penName?.user?.id)}
          commentCount={Number(data?.commentCount)}
          lastCommentDate={data?.lastCommentDate}
          refecthKey={['story-detail', Number(query?.id)]}
          commentable={data?.commentable}
          guestCommentable={data?.guestCommentable}
          isUserHasBlockedComment={data?.isUserHasBlockedComment}
        />
        <NavigateOtherStory bookId={Number(query?.id)} />
      </Container>
    </div>
  )
}
